.form {
    display: grid;
    grid-template-columns: 5fr 1fr;
    grid-template-areas:
        'heading heading'
        'input button';
    align-items: start;
    column-gap: var(--bi-scale-4x);
    row-gap: var(--bi-scale-1x);
}

.input {
    grid-area: input;
}

.submitButton {
    grid-area: button;
    margin-top: var(--bi-scale-8x);
}

.signUp,
.confirm {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-6x);
    color: var(--bi-primary-90);

    h1 {
        font: var(--bi-font-title-bold-large);
    }

    p {
        font: var(--bi-font-body-large);
    }
}

.helpText {
    white-space: pre-line;
}

.emailHeading {
    grid-area: heading;
    font: var(--bi-font-title-bold-small);
}
